import { AuthCtx, isExternalMarketplaceAccount } from 'context/auth'

export const EXTERNAL_MARKETPLACE_ALERT_HEIGHT = 48

export const shouldShowExternalMarketplaceAlert = (AuthContext: AuthCtx) => {
  return isExternalMarketplaceAccount(AuthContext)
}
